import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Mật khẩu không đúng!", -1)
const _hoisted_2 = { class: "login-signin railway-signin" }
const _hoisted_3 = { class: "railway-signin__header" }
const _hoisted_4 = {
  class: "railway-signin__title",
  ref: "titleEl"
}
const _hoisted_5 = {
  class: "railway-signin__desc",
  ref: "descEl"
}
const _hoisted_6 = {
  class: "railway-signin__field",
  ref: "fieldYear"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "railway-signin__label" }, "Năm làm việc", -1)
const _hoisted_8 = { class: "railway-signin__input-wrap" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar3 railway-signin__input-icon" }, null, -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  class: "railway-signin__field",
  ref: "fieldPhone"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "railway-signin__label" }, "Tài khoản", -1)
const _hoisted_13 = { class: "railway-signin__input-wrap" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person railway-signin__input-icon" }, null, -1)
const _hoisted_15 = { class: "railway-signin__error" }
const _hoisted_16 = {
  class: "railway-signin__field",
  ref: "fieldPassword"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "railway-signin__label" }, "Mật khẩu", -1)
const _hoisted_18 = { class: "railway-signin__input-wrap" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock railway-signin__input-icon" }, null, -1)
const _hoisted_20 = { class: "railway-signin__error" }
const _hoisted_21 = {
  class: "railway-signin__submit-wrap",
  ref: "submitWrap"
}
const _hoisted_22 = {
  type: "submit",
  id: "kt_login_signin_submit",
  class: "railway-signin__submit",
  ref: "submitBtn"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-in-right railway-signin__submit-icon" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_CustomDialog = _resolveComponent("CustomDialog")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CustomDialog, {
      "is-display": _ctx.isCustomDialogDisplay,
      width: '20%',
      title: "Có lỗi xảy ra khi đăng nhập",
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCustomDialogDisplay = false))
    }, {
      "dialog-content": _withCtx(() => [
        _hoisted_1
      ]),
      "dialog-footer": _withCtx(() => [
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.CANCEL,
          "color-type": _ctx.ButtonTypeColors.DANGER,
          "delay-time": 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCustomDialogDisplay = false))
        }, {
          "button-label": _withCtx(() => [
            _createTextVNode("Đã hiểu")
          ]),
          _: 1
        }, 8, ["button-type", "color-type"])
      ]),
      _: 1
    }, 8, ["is-display"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, "Đăng nhập", 512),
        _createElementVNode("p", _hoisted_5, " Hệ thống quản lý vật tư phụ tùng — Sửa chữa toa xe ", 512)
      ]),
      _createVNode(_component_Form, {
        class: "form",
        id: "kt_login_signin_form",
        onSubmit: _ctx.onSubmitLogin,
        "validation-schema": _ctx.login
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedYear) = $event)),
                class: "railway-signin__select"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workingYears, (y) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: y,
                    key: y
                  }, _toDisplayString(y), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedYear]
              ])
            ])
          ], 512),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_Field, {
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.phone) = $event)),
                class: "railway-signin__input",
                type: "text",
                name: "phone",
                placeholder: "Nhập tài khoản",
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_ErrorMessage, { name: "phone" })
            ])
          ], 512),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_Field, {
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password) = $event)),
                class: "railway-signin__input",
                type: "password",
                name: "password",
                placeholder: "Nhập mật khẩu",
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ], 512),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", _hoisted_22, [
              _hoisted_23,
              _createTextVNode(" Đăng nhập ")
            ], 512)
          ], 512)
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 64))
}